/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonUser,
    JsonUserFromJSON,
    JsonUserFromJSONTyped,
    JsonUserToJSON,
} from './JsonUser';

/**
 * 
 * @export
 * @interface ApiResultOfJsonUser
 */
export interface ApiResultOfJsonUser {
    /**
     * 
     * @type {JsonUser}
     * @memberof ApiResultOfJsonUser
     */
    data?: JsonUser;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonUser
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonUser
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonUser
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonUser
     */
    result?: ApiResultOfJsonUserResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonUserResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonUserFromJSON(json: any): ApiResultOfJsonUser {
    return ApiResultOfJsonUserFromJSONTyped(json, false);
}

export function ApiResultOfJsonUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonUserFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonUserToJSON(value?: ApiResultOfJsonUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonUserToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

